import ajax from "plugins/AjaxService"


/**
 * retrieves all ALARMS
 * https://app.clickup.com/30373227/v/dc/wyxbb-20075/wyxbb-29195
 */
const index = () => ajax.get("alarms")

/**
 * retrieves the TYPOLOGIES dictionary { <label>: <code> } used in the ALARM overrides
 * NOTA: "noCamelize" e' obbligatorio, le chiavi sono label e humps le storpierebbe
 * (es. "Farm_code_1" -> "farmCode1")
 */
const typologies = (): Promise<{ data: { [label: string]: string } }> =>
	ajax.get("alarms/typologies", null, { noCamelize: true })

/**
 * modify or create ALARM
 * https://app.clickup.com/30373227/v/dc/wyxbb-20075/wyxbb-29215
 */
const manage = alarm => ajax.post("alarms/manage", alarm)

/**
 * delete a specific ALARM
 * https://app.clickup.com/30373227/v/dc/wyxbb-20075/wyxbb-29235
 */
const destroy = alarmCode => ajax.delete("alarms/manage", { alarmCode } )


const api = {
	index,
	typologies,
	manage,
	destroy,
}
export default api